import {useMemo} from 'react';
import {transformAccountDtoToPersonalAccount} from '~/contexts/UserAccount/account';
import {useAccountsApiClient} from '../useAccountsApiClient';
import {AccountsApiClient} from '../accountsApiClient';

class AccountsRepository {
  constructor(private readonly client: AccountsApiClient) {}

  public getPersonalAccount = async (email: string) => {
    const personalAccount = await this.client.get(`/accounts/personal`, {
      params: {
        query: {
          email
        }
      }
    });
    return transformAccountDtoToPersonalAccount(personalAccount);
  };
}

export const useAccountsRepository = () => {
  const client = useAccountsApiClient();

  return useMemo(() => new AccountsRepository(client), [client]);
};
